import { HostAppEventHandler } from "../manager/eventManager/HostAppEventHandler";
import { HostAppEvent } from "../manager/eventManager/HostAppEventReceiver";

export class OneNoteEventHandler extends HostAppEventHandler {

    constructor() {
        super();
    }

    public HandleEvent(event: HostAppEvent, eventInfo: any) {
        switch (event) {
            case HostAppEvent.ONENOTE_PAGE_CHANGED:
                this.emit(HostAppEvent[HostAppEvent.ONENOTE_PAGE_CHANGED], eventInfo.pageId);
                break;
            default:
                super.HandleEvent(event, eventInfo);
        }
    }
}